import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import type { AnalyticsTopCompany } from '../../services/api';

interface UsagePatternsTabProps {
  data?: AnalyticsTopCompany[];
}

const UsagePatternsTab: React.FC<UsagePatternsTabProps> = ({ data }) => {
  const chartData = data && data.length > 0
    ? data
    : [];

  if (chartData.length === 0) {
    return (
      <div className="tab-content">
        <div className="no-data-message">
          <p>No spending patterns data available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <div className="chart-container">
        <h3 className="chart-title">Top Companies by Spending (Leaderboard)</h3>
        <div className="chart-wrapper">
          <ResponsiveContainer width="100%" height={400}>
            <BarChart layout="vertical" data={chartData} margin={{ top: 20, right: 30, left: 40, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" horizontal={true} vertical={false} />
              <XAxis type="number" hide />
              <YAxis
                dataKey="name"
                type="category"
                tick={{ fontSize: 12, fill: '#64748b' }}
                axisLine={false}
                tickLine={false}
                width={100}
              />
              <Tooltip
                cursor={{ fill: '#f8fafc' }}
                contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                formatter={(value: number) => `₦${value.toLocaleString()}`}
              />
              <Bar
                dataKey="spending"
                fill="#ff6b35"
                radius={[0, 4, 4, 0]}
                barSize={32}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default UsagePatternsTab;
